document.addEventListener('DOMContentLoaded', function () {
  const revealElements = document.querySelectorAll(
    '.reveal-up, .reveal-fade'
  );

  if (!revealElements.length) return;

  // Respect users who have requested reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealElements.forEach(function (element) {
      element.classList.add('is-visible');
    });

    return;
  }

  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');

        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  revealElements.forEach(function (element) {
    observer.observe(element);
  });
});